import {
    CameraOutlined,
    MailOutlined,
    MinusCircleOutlined,
    PhoneOutlined,
    PlusCircleOutlined,
    ShopOutlined,
    UserOutlined,
} from "@ant-design/icons";
import {
    Button,
    Form,
    Input,
    Modal,
    Upload,
    notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { getBase64 } from "../../services/util";
import TextArea from "antd/lib/input/TextArea";
import HTTP from "../../services/httpService";
import "./Contacts.css";

function AddEditForm({ editRecord, handleCancel }) {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [title, setTitle] = useState("Add");
    const [imageUrl, setImageUrl] = useState();
    const [formData, setFormData] = useState({});

    useEffect(() => {
        editRecord && form.setFieldsValue({ ...editRecord });
        editRecord && setTitle("Edit");
        if (editRecord?.photo_url) {
            setImageUrl(editRecord.photo_url);
        }
        setOpen(true);
        return () => {
            setOpen(false);
        };
    }, []);

    const handleChange = async (info) => {
        getBase64(info.file, async (imageUrl) => {
            setFormData({ file_name: info.file.name, file_path: imageUrl });
            setImageUrl(imageUrl);
        });
    };

    async function handleSubmit(value) {
        delete value.user_avatar;

        let addFormData = Object.fromEntries(
            Object.entries(value).map(([key, value], cur) => {
                if (value == undefined) return [key, ""];
                return [key, value];
            }, {}),
        );

        if (Object.entries(formData).length > 0) {
            addFormData = { ...addFormData, ...formData };
            setFormData({});
        }

        const url = addFormData.id
            ? "/backOffice/editBackOfficeContact"
            : "/backOffice/addBackOfficeContact";

        if (addFormData.file_path && addFormData.file_path) {
            delete addFormData.photo_url;
        }

        const { success, message } = await HTTP(url, {
            ...addFormData,
            staff_id,
        });

        if (success) {
            setFormData({});
            handleCancel(1);
            return notification["info"]({ message });
        }
        handleCancel();
        notification["error"]({ message });
    }
    const multipleFields = (key, label) => (
        <Form.List name={key}>
            {(fields, { add, remove }) => {
                if (!fields.length) setTimeout(() => add(), 10);
                return (
                    <div className="contacts-form-list">
                        {fields.map((field, index) => (
                            <div
                                key={field.key}
                                className="contacts-form-list-item"
                            >
                                <div className="contacts-form-list-item-header">
                                    <span className="contacts-form-list-item-title">
                                        {label} {index + 1}
                                    </span>
                                    {fields.length > 1 && (
                                        <Button
                                            type="text"
                                            size="small"
                                            icon={<MinusCircleOutlined />}
                                            className="contacts-form-list-remove"
                                            onClick={() => remove(field.name)}
                                        />
                                    )}
                                </div>
                                <div className="contacts-form-grid contacts-form-grid-compact">
                                    <Form.Item
                                        name={[field.name, "first_name"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter First Name..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            prefix={<UserOutlined />}
                                            placeholder="First Name"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={[field.name, "last_name"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Last Name..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="text"
                                            prefix={<UserOutlined />}
                                            placeholder="Last Name"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name={[field.name, "email"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Email..!",
                                            },
                                            {
                                                type: "email",
                                                message:
                                                    "Please Enter Valid Email..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            type="email"
                                            prefix={<MailOutlined />}
                                            placeholder="Email"
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name={[field.name, "number"]}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please Enter Phone..!",
                                            },
                                            {
                                                pattern: /^(?:\d*)$/,
                                                message:
                                                    "Only Digits Allowed..!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            prefix={<PhoneOutlined />}
                                            placeholder="Phone"
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        ))}
                        {fields.length < 2 && (
                            <Button
                                type="dashed"
                                icon={<PlusCircleOutlined />}
                                className="contacts-form-list-add"
                                onClick={() => add()}
                            >
                                Add {label}
                            </Button>
                        )}
                    </div>
                );
            }}
        </Form.List>
    );

    return (
        <Modal
            open={open}
            title={
                <div className="contacts-modal-header">
                    <div className="contacts-modal-title">
                        {title} Back-office Contact
                    </div>
                    <div className="contacts-modal-subtitle">
                        Manage property details, contact groups, and supporting
                        notes in one structured form.
                    </div>
                </div>
            }
            onCancel={handleCancel}
            destroyOnHidden
            width={1100}
            footer={null}
            className="contacts-modal"
        >
            <Form
                form={form}
                name="basic"
                onFinish={handleSubmit}
                layout="vertical"
                className="contacts-form"
            >
                <div className="contacts-form-shell">
                    <div className="contacts-form-sidebar">
                        <Form.Item name="user_avatar" valuePropName="file">
                            <Upload
                                beforeUpload={() => false}
                                maxCount={1}
                                name="avatar"
                                listType="picture-card"
                                showUploadList={false}
                                onChange={handleChange}
                                accept=".jpg,.png"
                            >
                                {imageUrl ? (
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        className="contacts-upload-image"
                                    />
                                ) : (
                                    <div className="contacts-upload-placeholder">
                                        <CameraOutlined />
                                        <div className="contacts-upload-text">
                                            Upload Photo
                                        </div>
                                    </div>
                                )}
                            </Upload>
                        </Form.Item>
                        <div className="contacts-sidebar-help">
                            Add a photo to make the contact easier to identify
                            in the table and detail views.
                        </div>
                    </div>
                    <div className="contacts-form-content">
                        <div className="contacts-form-section">
                            <div className="contacts-form-section-title">
                                Property Information
                            </div>
                            <div className="contacts-form-grid">
                                <Form.Item
                                    label="Property Name"
                                    name="property_name"
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "Please Enter Property Name..!",
                                        },
                                    ]}
                                >
                                    <Input
                                        id="property_name"
                                        prefix={<ShopOutlined />}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Company"
                                    name="company_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Company..!",
                                        },
                                    ]}
                                >
                                    <Input id="company" />
                                </Form.Item>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[
                                        { type: "email" },
                                        {
                                            required: true,
                                            message: "Please Enter Email..!",
                                        },
                                    ]}
                                >
                                    <Input id="email" prefix={<MailOutlined />} />
                                </Form.Item>
                                <Form.Item label="Web Page" name="web_page">
                                    <Input id="web_page" />
                                </Form.Item>
                                <Form.Item
                                    label="Fax Number"
                                    name="fax_number"
                                    rules={[
                                        {
                                            pattern: /^(?:\d*)$/,
                                            message: "Only Digits Allowed..!",
                                        },
                                    ]}
                                >
                                    <Input
                                        id="fax_number"
                                        prefix={<PhoneOutlined />}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Category"
                                    name="category"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Category..!",
                                        },
                                    ]}
                                >
                                    <Input id="category" />
                                </Form.Item>
                                <Form.Item
                                    label="Street"
                                    name="street"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Street..!",
                                        },
                                    ]}
                                >
                                    <Input id="street" />
                                </Form.Item>
                                <Form.Item
                                    label="City"
                                    name="city"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter City..!",
                                        },
                                    ]}
                                >
                                    <Input id="city" />
                                </Form.Item>
                                <Form.Item
                                    label="State"
                                    name="state_name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter State..!",
                                        },
                                    ]}
                                >
                                    <Input id="state_name" />
                                </Form.Item>
                                <Form.Item
                                    label="Zip"
                                    name="zip_code"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Zip..!",
                                        },
                                        {
                                            pattern: /^(?:\d*)$/,
                                            message: "Only Digits Allowed..!",
                                        },
                                    ]}
                                >
                                    <Input id="zip_code" />
                                </Form.Item>
                                <Form.Item
                                    label="Country"
                                    name="country"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Country..!",
                                        },
                                    ]}
                                >
                                    <Input id="country" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="contacts-form-section">
                            <div className="contacts-form-section-title">
                                Contact Groups
                            </div>
                            <div className="contacts-contact-groups">
                                <div className="contacts-contact-group">
                                    <div className="contacts-contact-group-title">
                                        Owner Contacts
                                    </div>
                                    {multipleFields("phone_number", "Owner Contact")}
                                </div>
                                <div className="contacts-contact-group">
                                    <div className="contacts-contact-group-title">
                                        Operation Contacts
                                    </div>
                                    {multipleFields(
                                        "business_phone_number",
                                        "Operation Contact",
                                    )}
                                </div>
                                <div className="contacts-contact-group">
                                    <div className="contacts-contact-group-title">
                                        Account Contacts
                                    </div>
                                    {multipleFields(
                                        "account_phone_number",
                                        "Account Contact",
                                    )}
                                </div>
                                <div className="contacts-contact-group">
                                    <div className="contacts-contact-group-title">
                                        Hotel Contacts
                                    </div>
                                    {multipleFields("mobile_number", "Hotel Contact")}
                                </div>
                            </div>
                        </div>
                        <div className="contacts-form-section">
                            <div className="contacts-form-section-title">
                                Notes
                            </div>
                            <Form.Item name="notes" label="Additional notes">
                                <TextArea rows={4} />
                            </Form.Item>
                            <Form.Item name="id" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item name="photo_url" hidden>
                                <Input />
                            </Form.Item>
                        </div>
                    </div>
                </div>

                <div className="contacts-form-actions">
                    <Button onClick={() => handleCancel()}>Cancel</Button>
                    <Button type="primary" htmlType="submit">
                        Save Contact
                    </Button>
                </div>
            </Form>
        </Modal>
    );
}

export default AddEditForm;
